import { useMemo } from 'react';
import type { MasterAccountPermission } from '@insio/shared-types';
import { useAuth } from '../context';
import { masterPermissionCheck } from '../utils/master-context';

export interface UseMasterPermissionsReturn {
  /** True when the caller's roles in the current master account grant the permission. */
  hasMasterPermission: (permission: MasterAccountPermission) => boolean;
}

/**
 * Master-account permissions of the signed-in person — the board's counterpart of
 * `usePermissions`, read from the same role map the backend's master scope guard uses.
 */
export function useMasterPermissions(): UseMasterPermissionsReturn {
  const { user } = useAuth();
  const currentMasterAccount = user?.currentMasterAccount;
  const hasMasterPermission = useMemo(
    () => masterPermissionCheck({ currentMasterAccount }),
    [currentMasterAccount]
  );
  return { hasMasterPermission };
}
